import { useEffect, useState } from "react";
import "../../assets/Css/logs-model.css";

const StockTable = ({
  logResponse,
  currentTimeLogs,
  isOpen,
  onClose,
  dataBtn,
  ApiUrl,
  candlesInterval
}) => {
  const [selectedSymbol, setSelectedSymbol] = useState("");
  const [currentSignals, setCurrentSignals] = useState({}); // should be an object

  useEffect(() => {
    if (!logResponse) return;

    let grouped = {};

    // Case 1: already grouped
    const isGrouped = Object.keys(logResponse).every(
      (key) => Array.isArray(logResponse[key])
    );

    if (isGrouped) {
      grouped = logResponse;
    } else if (logResponse?.data?.length) {
      setSelectedSymbol(logResponse?.data[0]?.symbol);

      grouped = logResponse.data.reduce((acc, item) => {
        if (!acc[item.type]) acc[item.type] = [];
        acc[item.type].push(item);
        return acc;
      }, {});
    }

    setCurrentSignals(grouped);
  }, [logResponse]);

  if (!isOpen) return null;

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    if (isNaN(date)) return timestamp; // fallback if already string
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getColor = (symbol) => {
    const colors = [
      "#e3f2fd", // light blue
      "#fce4ec", // light pink
      "#e8f5e9", // light green
      "#fff3e0", // light orange
      "#ede7f6", // light purple
      "#f3e5f5", // lavender
      "#e0f7fa", // light cyan
      "#f1f8e9", // light lime
      "#fffde7", // light yellow
      "#fbe9e7", // light coral
      "#edeef7", // light indigo
      "#e6f3f8", // light teal
    ];
    const hash = symbol
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  const SignalColumn = ({ title, data }) => {
    return (
      <div className="popup-column">
        <h4>{title}</h4>
        <ul className="popup-signal-list">
          {data?.length > 0 ? (
            data.map((item, index) => (
              <li
                key={index}
                className="popup-signal-item"
                style={{ backgroundColor: getColor(item.symbol) }}
              >
                <div><b>{item.symbol}</b> - Date: {formatDate(item.timestamp)}</div>
                <div>Open: {item.open} | High: {item.high} | Low: {item.low} | Close: {item.close}</div>
                <div>Signal High: {item.signalHigh} | Signal Low: {item.signalLow}</div>
              </li>
            ))
          ) : (
            <li className="popup-signal-item">No data</li>
          )}
        </ul>
      </div>
    );
  };


  return (
    <>
      <div className="popup-overlay" onClick={onClose}>
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <button className="popup-close" onClick={onClose}>×</button>
          <div className="popup-body">
            {dataBtn === "currentTimeSignals" ? (
              <>
                <table className="popup-table-2">
                  <thead>
                    <tr>
                      <th>Buy</th>
                      <th>Sell</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {currentTimeLogs
                          ?.filter((item) => item.type === "BUY")
                          .map((item, index) => (
                            <span
                              key={index}
                              className="symbol-box"
                              style={{ backgroundColor: getColor(item.symbol) }}
                            >
                              {item.symbol}
                            </span>
                          ))}
                      </td>
                      <td>
                        {currentTimeLogs
                          ?.filter((item) => item.type === "SELL")
                          .map((item, index) => (
                            <span
                              key={index}
                              className="symbol-box"
                              style={{ backgroundColor: getColor(item.symbol) }}
                            >
                              {item.symbol}
                            </span>
                          ))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            ) : (
              <>
                {dataBtn === "5MOperations" && (
                  <>
                    <h3 className="popup-heading">5 Minute Operations</h3>
                    <div className="grid-two-cols">
                      <SignalColumn title="Directional Bullish @ 5M" data={currentSignals.directionalBullish} />
                      <SignalColumn title="Directional Bearish @ 5M" data={currentSignals.directionalBearish} />
                    </div>
                    <div className="grid-two-cols">
                      <SignalColumn title="Piercing Bullish @ 5M" data={currentSignals.piercingBullish} />
                      <SignalColumn title="Piercing Bearish @ 5M" data={currentSignals.piercingBearish} />
                    </div>
                    <div className="grid-two-cols">
                      <SignalColumn title="Gap Up @ 5M" data={currentSignals.gapUp} />
                      <SignalColumn title="Gap Down @ 5M" data={currentSignals.gapDown} />
                    </div>
                  </>
                )}
                {dataBtn === "15MOperations" && (
                  <>
                    <h3 className="popup-heading">15 Minute Operations</h3>
                    <div className="grid-two-cols">
                      <SignalColumn title="Directional Bullish @ 15M" data={currentSignals.directionalBullish} />
                      <SignalColumn title="Directional Bearish @ 15M" data={currentSignals.directionalBearish} />
                    </div>
                    <div className="grid-two-cols">
                      <SignalColumn title="Piercing Bullish @ 15M" data={currentSignals.piercingBullish} />
                      <SignalColumn title="Piercing Bearish @ 15M" data={currentSignals.piercingBearish} />
                    </div>
                    <div className="grid-two-cols">
                      <SignalColumn title="Gap Up @ 15M" data={currentSignals.gapUp} />
                      <SignalColumn title="Gap Down @ 15M" data={currentSignals.gapDown} />
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default StockTable;
